import React from 'react'
import { useDispatch } from 'react-redux'
import ReactTexty from 'react-texty'
import { Typography } from '../../../atomic-design-components'
import { popupAlertShow } from '../../../redux-saga/actions'
import theme from '../../../theme'

const TextWithCopyOnClick = ({
  cellData,
  columns,
  column,
  columnIndex,
  rowData,
  rowIndex,
  container,
  isScrolling,
  textVariant,
}) => {
  const dispatch = useDispatch()

  const handleClick = (event) => {
    event.stopPropagation()
    setTimeout(
      async () =>
        await navigator.clipboard.writeText(cellData).then(
          function () {
            console.log('Copy to clipboard successfully.')
          },
          function () {
            console.log('Copy to clipboard unsuccessfully.')
          }
        )
    )

    dispatch(
      popupAlertShow({
        contentKey: 'dataCopied',
        type: 'success',
        withCloseButton: true,
        iconName: 'copy',
      })
    )
  }

  return (
    <Typography
      variant={textVariant || 'body2'}
      color={theme.color.secondary.main}
      className={'emailForCopy'}
      onClick={handleClick}
      as={ReactTexty}
    >
      {cellData}
    </Typography>
  )
}

export default TextWithCopyOnClick
